<input #fileInput type='file' class="file-input" [attr.accept]="getAcceptedFileExtensions()" (change)="fileSelected($event)">

<ng-container>
    <div class="drag-drop-file" [class.has-error]="getErrorMessage()" [class.drag-over]="isDragOver" [class.has-file]="hasContentSelected" [class.violated]="violated"   (dragenter)="notDragOver($event)" [class.disabled]="disabled" (dragover)="dragOver($event)"
    (dragleave)="notDragOver($event)" (drop)="fileDropped($event)">



    <div class="file-content" tabindex="0" *ngIf="!showLoader">

      <!-- Upload icon -->
      <span *ngIf="!hasContentSelected" class="hd-icon hd-icon-plus icon-xxlg upload-icon add-icon"></span>
      <span *ngIf="hasContentSelected" class="hd-icon {{getUploadContentTypeIcon()}} upload-icon icon-28-fontsize"></span>

      <!-- Placeholder for upload content message -->
      <span *ngIf="hasUploadPlaceholder" class="upload-desc">{{getPlaceholderText()}}</span>

      <ng-container *ngIf="tempFile|| hasContentSelected || (refreshFile && violated)">

        <div class="display-content-text">
          <span *ngIf="!uploadDescription && !hasMultipleFilesUpload" [ngClass]="{'folder-selected': hasFolderContentUploaded}" class="content-name" sa-ellipsis [fullText]="getSelectedContentDescription()" placement = top></span>
          <span *ngIf="!uploadDescription && hasMultipleFilesUpload" class="content-name"  [soti-tooltip]="getUploadContentToolTipText()"
                placement=top>{{getSelectedContentDescription()}}</span>
          <span *ngIf="!uploadDescription && hasFolderContentUploaded" class="content-name folder-pipe-content" [soti-tooltip]="getUploadContentToolTipText()"
          placement=top>{{ pipeContent}}</span>
        </div>

        <!-- Delete button to delete selected content -->
        <div class="close" [class.disabled]="disabled" (click)="confirmDelete = !confirmDelete; removeFile($event)">
            <div class="xs-remove-btn"></div>
        </div>
      </ng-container>

      <!-- Browse Files/Folder -->
      <ng-container>
        <span *ngIf="!isFolderUpload" class="browse-file" (click)="openFileExplorer(true)">{{getFilesLinkText()}}</span>
        <div *ngIf="isFolderUpload">
          <span class="browse-file" (click)="openFileExplorer(true)">{{getFilesLinkText()}}</span>
          <span class="or-text">OR</span>
          <span class="browse-file" (click)="openFileExplorer(false)">{{getFolderLinkText()}}</span>
        </div>
      </ng-container>

      <!-- Container to display invalid files -->
      <ng-container *ngIf="tempFile&&!file">
        <span class="invalidfile-name">{{ tempFile.name }}</span>
      </ng-container>

    </div>

    <div class="file-content-error" *ngIf="getErrorMessage()">
      <span>{{ getErrorMessage() }}</span>
    </div>

    <!--Show File Loader Spinner-->
    <div class="file-content" tabindex="0" *ngIf="showLoader">
      <mat-spinner class="upload-spinner" [diameter]=30 [strokeWidth]=2></mat-spinner>
      <span class="upload-desc uploading">{{ getUploadingMessage() }}</span>
      <ng-container>
        <span class="cancel-file-upload" (click)="cancelFileUpload()">Cancel</span>
      </ng-container>
    </div>
  </div>
</ng-container>